export const SEARCH_POSTAL_CODE = 'SEARCH_POSTAL_CODE';
